import React from 'react'
import css from './Inspect.module.css'
import { Review } from 'hhsoig-design-system-core'
import {
  formatPersonName,
  formatReviewString,
  reviewHhsPrograms
} from '../../utilities'
import { Divider } from '../divider'
import { PrintReview } from '../PrintReview'
import { ReviewGrantsContracts } from '../ReviewGrantsContracts'
import { ReviewSubjects } from '../ReviewSubjects'
import {
  complaintTypeLabel,
  jobTitleLabel,
  nameLabel,
  officePhoneLabel,
  workCellPhoneLabel,
  workEmailLabel
} from '../../strings/labels'

import { complaintDescription } from './Inspect'

const complaint_choices = require('../../choices/json/complaint_type.json')

export const InspectOpDiv = ({ goBackToPage, pages, values, setFocusName }) => {
  const program_details = reviewHhsPrograms(values)

  const complainant_details = [
    {
      heading: 'Are you the point of contact (POC) for this investigation?',
      field_name: 'poc_reporting',
      value: formatReviewString(values.poc_reporting)
    },
    {
      heading: nameLabel,
      field_name: 'first_name',
      value: formatReviewString(
        formatPersonName(
          values.first_name,
          values.middle_name,
          values.last_name,
          values.suffix
        )
      )
    },
    {
      heading: jobTitleLabel,
      field_name: 'employment__job_title',
      value: formatReviewString(values.employment__job_title)
    }
  ]

  const complainant_contact_details = [
    {
      heading: workEmailLabel,
      field_name: 'employment__email',
      value: formatReviewString(values.employment__email)
    },
    {
      heading: officePhoneLabel,
      field_name: 'employment__phone',
      value: formatReviewString(values.employment__phone)
    },
    {
      heading: workCellPhoneLabel,
      field_name: 'employment__phone2',
      value: formatReviewString(values.employment__phone2)
    }
  ]

  let description_details = [
    {
      heading: complaintTypeLabel,
      field_name: 'complaint_type',
      value: formatReviewString(complaint_choices[values.complaint_type])
    }
  ]
  description_details = description_details.concat(complaintDescription(values))

  const onEditClick = fieldName => {
    goBackToPage(findPageIdOfField(fieldName, pages))
    setFocusName(fieldName)
  }

  const findPageIdOfField = name => {
    let page
    page = pages.find(p => p.fields.some(f => f.name === name))
    if (!page) {
      // if page not found, search conditional fields
      page = pages.find(p =>
        p.fields.some(fld => {
          let conditionalFld
          if (fld.conditionals) {
            conditionalFld = fld.conditionals.find(c =>
              c.fields.some(f => f.name === name)
            )
            return conditionalFld ? true : false
          } else {
            return false
          }
        })
      )
    }
    return page ? page.id : null
  }

  // Create and return a <Review> tag for each detail object in 'details'.
  // The detail objects are defined above, and have 3 elements:
  // heading, field_name, value
  const iterateDetails = details => {
    return details.map((detail, i) => {
      const additionalProps = detail.omitEdit
        ? {}
        : {
            onEditClick: () => {
              goBackToPage(findPageIdOfField(detail.field_name, pages))
              setFocusName(detail.field_name)
            },
            editHref: 'javascript:void(0)'
          }
      return (
        <Review
          className={css.reviewContent}
          key={`${detail.field_name}_${i}`}
          heading={detail.heading}
          {...additionalProps}
        >
          {detail.value}
        </Review>
      )
    })
  }

  return (
    <div data-testid="review-complaint">
      <h1 className="form-pg-title">Your complaint summary</h1>
      <p className="ds-text">
        Before you submit, make sure you check your information and save or
        print a copy for your records.
      </p>
      <h2 id="opdiv">Operating division</h2>
      {iterateDetails(program_details)}

      <h2 id="poc">Point of contact</h2>
      {iterateDetails(complainant_details)}
      <h3>Work contact information</h3>
      {iterateDetails(complainant_contact_details)}

      <h2 id="complaint">
        Complaint
        <span id="attachments" />
      </h2>
      {iterateDetails(description_details)}
      {values.awards && (
        <React.Fragment>
          <h2>Grant/Contract information</h2>
          <ReviewGrantsContracts values={values} onClick={onEditClick} />
        </React.Fragment>
      )}
      <h2 id="subject">Subject information</h2>
      <ReviewSubjects values={values} onClick={onEditClick} />

      <PrintReview className={css.printReview} />
      <Divider />
    </div>
  )
}
